import React from 'react'

import Logo from '@/app/component/atom/logo'
import { Balance, Organization, SelectOption } from '@/app/types'

import { Content, HelpMenuContainer, Right, StyledLink } from './common'
import DesktopAccountMenu from './desktop-account-menu'
import DesktopNav from './desktop-nav'
import FeedbackButton from './feedback-button'
import HelpMenu from './help-menu'
import NonAuthNav from './non-auth-nav'

type Props = {
  activeOrg?: Organization
  balance?: Balance
  currentPage: string
  email: string
  organizations?: SelectOption<number>[]
  isAuthorized: boolean
  hasOrg: boolean
  accountMenuOpen: boolean
  orgListExpanded: boolean
  onAccountMenuToggle: () => void
  onOrgSelect: (org: SelectOption<number>) => void
  onPanelToggle: () => void
  logout?: () => void
}

const DesktopHeader: React.FC<Props> = ({
  activeOrg,
  balance,
  currentPage,
  email,
  organizations = [],
  isAuthorized,
  hasOrg,
  accountMenuOpen,
  orgListExpanded,
  onAccountMenuToggle,
  onOrgSelect,
  onPanelToggle,
  logout = () => {},
}) => (
  <>
    <StyledLink to="/">
      <Logo />
    </StyledLink>
    <Content>
      {hasOrg && <DesktopNav currentPage={currentPage} />}
      <Right>
        <HelpMenuContainer>
          {isAuthorized && <FeedbackButton />}
          <HelpMenu classes={{ dropdownLink: '' }} />
        </HelpMenuContainer>
        {isAuthorized && (
          <DesktopAccountMenu
            activeOrg={activeOrg}
            balance={balance}
            currentPage={currentPage}
            email={email}
            organizations={organizations}
            hasOrg={hasOrg}
            accountMenuOpen={accountMenuOpen}
            orgListExpanded={orgListExpanded}
            logout={logout}
            onAccountMenuToggle={onAccountMenuToggle}
            onOrgSelect={onOrgSelect}
            onPanelToggle={onPanelToggle}
          />
        )}
        {!isAuthorized && <NonAuthNav currentPage={currentPage} />}
      </Right>
    </Content>
  </>
)

export default DesktopHeader
